import Cookies from "universal-cookie/es6";
import initialState from "./initialState";

export const requestFunc = (state, { queryOptions }) => ({
  ...state,
  isFetching: true,
  queryOptions,
});

export const receiveFunc = (state, { data }) => ({
  ...state,
  isFetching: false,
  errorMessage: null,
  data,
});

export const failureFunc = (state, { errorMessage }) => ({
  ...state,
  isFetching: false,
  errorMessage,
});

export const initialFunc = (ctx) => {
  // destroyCookie(null, 'accessToken');
  const cookies = new Cookies();
  cookies.remove("accessToken", { path: "/" });
  return { ...initialState };
};
